import { Dropdown, Table, Tabs } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchContactFolders,
  fetchContacts,
  setGradUpload,
  setGraduateListObj,
} from "../../features/contact/ContactSlice";
import { useNavigate } from "react-router-dom";
import InsideHeader from "../../components/InsideHeader";
import PersonnelListView from "./PersonnelListView";
import PersonnelAdd from "./PersonnelAdd";
import DependantTable from "./dependants/DependantTable";
import NextOfKinTable from "./next-of-kin/NextOfKinTable";
import ThirdPartyUsersTable from "./ThirdPartyUsers/ThirdPartyUsersTable"
import { fetchSinglePersonnel, setRefetch, setRefetchKey } from "../../features/folder/folderSlice";
import toast from "react-hot-toast";
import EmployeeBenefitTable from "./employee-benefit/EmployeeBenefitTable";
import EmployeeSpecificationTable from "./employee-specification/EmployeeSpecificationTable";

export default function PersonnelFolderView() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { folderObj } = useSelector((state) => state.folder);
  const { gradLoading, contactsHeaders, contacts } = useSelector(
    (state) => state.contact
  );

 

  const [active, setactive] = useState("1");
  async function refetching(activeKey) {
    await dispatch(setRefetch());
    await dispatch(setRefetchKey(activeKey));
    if(folderObj?.ppId){
      await setactive(activeKey);
    }else{
      toast.error("You should have personnel ")
    }
    
  }

  const tabConfigurations = [
    {
      label: (
        <span className="flex items-center">
          <span className=" ">Personnel Details</span>
        </span>
      ),
      key: "1",
      children: <PersonnelAdd active={active} setactive={setactive} />,
    },

    {
      label: (
        <span className="flex items-center">
          <span className="">Dependants</span>
        </span>
      ),
      key: "2",
      children: <DependantTable folderObj={folderObj}/>,
    },
    {
      label: (
        <span className="flex items-center">
          <span className="">Next of Kins</span>
        </span>
      ),
      key: "3",
      children: <NextOfKinTable  folderObj={folderObj}/>,
    },
    {
      label: (
        <span className="flex items-center">
          <span className="">Employee Benefits</span>
        </span>
      ),
      key: "4",
      children: <EmployeeBenefitTable  folderObj={folderObj}/>,
    },
    {
      label: (
        <span className="flex items-center">
          <span className="">Employee Specifications</span>
        </span>
      ),
      key: "6",
      children: <EmployeeSpecificationTable  folderObj={folderObj}/>,
    },
    {
      label: (
        <span className="flex items-center">
          <span className="">Users In Other</span>
        </span>
      ),
      key: "5",
      children: <ThirdPartyUsersTable  folderObj={folderObj}/>,
    },
  ];

  async function fetchSinglePersonnelData() {
    await dispatch(fetchSinglePersonnel({
      criteria:"ppPfno",
      txtSearch:folderObj?.ppPfno
    }));
  }

  useEffect(() => {
    fetchSinglePersonnelData();
  }, [folderObj]);



  useEffect(() => {}, [contactsHeaders]);
  useEffect(() => {}, [contacts]);
 
  return (
    <div className="w-full h-full overflow-y-scroll">
      <InsideHeader
        title="Personnel Profile"
        subtitle="Manage personnel profile within your institution"
        back={true}
        title1="Personnel"
        title2="personnel Add"
      />

      <div className="dash-inner-page mt-[1.25rem] h-full rounded-[10px] lg:px-10 px-3">
        <div className="flex items-center justify-between w-full  ">
          <div className="mt-[1.25rem]">
            <h3 className="dash-title font-[700] text-[24px] text-black1">
              {folderObj?.ppFullname}
            </h3>
          </div>
        </div>

        <div className="h-[111px]  mt-[1rem] ">
          <Tabs
            items={tabConfigurations}
            defaultActiveKey="1"
            activeKey={active}
            onChange={refetching}
            className="activity-tab activity-tab-wrap activity-bar"
          />
        </div>
      </div>
    </div>
  );
}
